var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultRendererConfig, setupBingAerialImagery } from "./index";
import { repeat } from "../framework/utils";
import { Runner } from "../framework/Runner";
import { AnimationTrack } from "../framework/AnimationTrack";
import { MoveAnimator } from "../framework/MoveAnimator";
import { WaitAnimator } from "../framework/WaitAnimator";
import { PointCloudStyle } from "../../api";
import { Cartographic, Ellipsoid } from "../../private/math";
import { Vector3 } from "three";
import { EventAnimator } from "../framework/EventAnimator";
const brown = { r: 0.5, g: 0.25, b: 0 };
const greenyellow = { r: 0.68, g: 1, b: 0.184 };
const green = { r: 0, g: 1, b: 0 };
const darkgreen = { r: 0, g: 0.5, b: 0 };
const gray = { r: 0.7, g: 0.7, b: 0.7 };
const orange = { r: 1, g: 0.65, b: 0 };
const blue = { r: 0, g: 0, b: 1 };
const classificationColors = {
    0: { base: green, show: false },
    1: { base: brown, show: true },
    2: { base: brown, show: true },
    3: { base: greenyellow, show: true },
    4: { base: green, show: true },
    5: { base: darkgreen, show: true },
    6: { base: gray, show: true },
    7: { base: orange, show: true },
    8: { base: darkgreen, show: true },
    9: { base: blue, show: true },
    10: { base: gray, show: true },
    11: { base: darkgreen, show: true },
    12: { base: darkgreen, show: true },
    13: { base: darkgreen, show: true },
    14: { base: darkgreen, show: true },
    15: { base: darkgreen, show: true },
    16: { base: darkgreen, show: true },
    17: { base: darkgreen, show: true },
    18: { base: darkgreen, show: true },
};
const STYLE = {
    pointStyle: PointCloudStyle.ClassificationColoring,
    opacity: 0.1,
    pointSize: 5,
    classificationColors,
};
export function movingClassificationColor1(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Moving Classification Color 1" +
                "</h1>" +
                "<p>" +
                "A point cloud will use classification colouring, periodically moving up and down to test the colour under " +
                "movement. The colour should always stay the same regardless of the position of the point cloud (ignoring " +
                "transparency)." +
                "</p>";
        const durations = repeat([2, 2], 3);
        const positions = repeat([
            [0, 0, 0],
            [0, 0, -10],
        ], 3);
        yield Runner.run(defaultRendererConfig(container), (renderer, camera) => __awaiter(this, void 0, void 0, function* () {
            // Scene setup
            setupBingAerialImagery(renderer);
            const object = yield renderer.getObjectFactory().createTileset({
                type: "direct",
                url: "https://s3.ap-southeast-2.amazonaws.com/skand.production.sites/6004efa38c5e39004cb67c6f/600a22ac16ff08004edeb648/614162629a4611004e17c1a8/Files/Tileset3d/61bac8ea367cd4004d93e27f/tileset.json",
                style: STYLE,
            });
            renderer.getWorld().addObject(object);
            // Setup camera position
            camera.setPositionCartographic({
                longitude: 2.5065544518598286,
                latitude: -0.6689024232266954,
                height: 172.69506807293857,
            });
            const up = new Vector3();
            Ellipsoid.WGS_84.rotationBasisForCartographic(Cartographic.fromApi(camera.getPositionCartographic()), null, up);
            camera.setUpVector(up);
            camera.lookAt({ x: -4032945.0811595763, y: 2972598.385502797, z: -3933885.076640211 });
            const numSteps = Math.min(positions.length, durations.length);
            const pTrack = new AnimationTrack();
            for (let i = 0; i < numSteps - 1; i += 1) {
                pTrack.add(durations[i + 1], (beginTime, endTime) => {
                    return MoveAnimator.between(beginTime, endTime, object, {
                        start: positions[i],
                        end: positions[i + 1],
                    });
                });
                pTrack.add(4, WaitAnimator.between);
                pTrack.add(0.1, (beginTime, endTime) => EventAnimator.at(beginTime, endTime, () => {
                    object.applyStyle(STYLE);
                }));
                pTrack.add(4, WaitAnimator.between);
            }
            // Output the tracks
            return [pTrack];
        }));
    });
}
